import React, { Suspense, useEffect } from 'react';
import Card from '@/components/card';
import { Tabs, TabsProps } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import OrderInfo from './components/order-info';
import BreadcrumbComponent from '@/components/breadcrumb';
import { useQuery } from '@tanstack/react-query';
import { getOrder } from '@/adapters/order';
import { IOrder } from '@/interfaces/order';
import OrderFiles from './components/order-files';
import OrderReceiveQr from './components/order-receive-qr';
import { useMedia } from '@/contexts/MediaContext';
import OrderPackingList from './components/order-packing-list';

const OrderDetail = () => {
  const { setMedia } = useMedia();
  const navigate = useNavigate();
  const { id } = useParams();
  const { data: order, refetch } = useQuery<IOrder, Error>({
    queryKey: ['get-order', id],
    queryFn: async () => await getOrder(Number(id)),
  });

  const items: TabsProps['items'] = [
    {
      key: 'product-info',
      label: 'ข้อมูลออเดอร์',
      children: (
        <Suspense>
          {order && <OrderInfo data={order} onRefresh={() => refetch()} />}
        </Suspense>
      ),
    },
    {
      key: 'documents',
      label: 'เอกสารต่างๆ',
      children: <Suspense>{order && <OrderFiles data={order} />}</Suspense>,
    },
    {
      key: 'QR รับเงิน',
      label: 'QR รับเงิน',
      children: <Suspense>{order && <OrderReceiveQr data={order} />}</Suspense>,
      forceRender: true,
    },
    {
      key: 'delivery-note-status',
      label: 'Delivery Note Status',
      children: <Suspense>{order && <OrderReceiveQr data={order} />}</Suspense>,
    },
    {
      key: 'Packing List',
      label: 'Packing List',
      children: (
        <Suspense>{order && <OrderPackingList data={order} />}</Suspense>
      ),
      forceRender: true,
    },
  ];

  useEffect(() => {
    return () => {
      setMedia(undefined);
    };
  }, []);

  return (
    <Card>
      <BreadcrumbComponent
        items={[
          {
            title: (
              <div
                className="cursor-pointer"
                onClick={() => navigate(`/export`)}
              >
                Export
              </div>
            ),
          },
          {
            title: `${order?.code || ''}`,
          },
        ]}
      />
      <div className="flex flex-col gap-4">
        <Tabs
          defaultActiveKey="1"
          items={items}
          className="w-full"
          rootClassName="font-medium"
        />
      </div>
    </Card>
  );
};

export default OrderDetail;
